import React, { useCallback, useRef, useState } from "react";
import { motion } from "framer-motion";
import { appConfig } from "../config/appConfig";
import KeepOneArena from "./KeepOneArena";
import Wordmark from "./Wordmark";

// Exact-context face-off landing: recipient opens straight into THE matchup and
// can immediately KEEP ONE. Never a homepage, never zero.
export default function FaceoffScreen({ comparison, context, variant, reducedMotion, onChoose }) {
  const [chosenSide, setChosenSide] = useState(null);
  const lockRef = useRef(false);
  const round = { left: comparison.left, right: comparison.right };

  const resolve = useCallback(
    (side) => {
      if (lockRef.current) return;
      lockRef.current = true;
      setChosenSide(side);
      const selectedId = side === "left" ? comparison.left.id : comparison.right.id;
      const delay = reducedMotion ? 160 : appConfig.motion.advanceDelayMs + 120;
      setTimeout(() => onChoose(side, selectedId), delay);
    },
    [comparison, reducedMotion, onChoose]
  );

  return (
    <div className="relative flex flex-col h-[100dvh] w-full max-w-[520px] mx-auto tt-vignette">
      <header className="px-5 pt-[calc(env(safe-area-inset-top)+18px)] text-center">
        <Wordmark variant="horizontal" className="h-3.5" />
        <p className="mt-2 font-mono text-[10px] tracking-[0.24em] uppercase text-subtle">{context || "A shared face-off"}</p>
      </header>

      <div className="px-5 pt-3 pb-2 text-center">
        <h1 className="font-display font-black tracking-[-0.03em] text-2xl sm:text-3xl text-bone">KEEP ONE.</h1>
      </div>

      <main className="flex-1 min-h-0 px-4 pb-2">
        <motion.div
          initial={reducedMotion ? { opacity: 0 } : { opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: reducedMotion ? 0.12 : 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="h-full w-full"
        >
          <KeepOneArena round={round} variant={variant} chosenSide={chosenSide}
            onChoose={(side) => resolve(side)} reducedMotion={reducedMotion} />
        </motion.div>
      </main>

      <footer className="px-5 pt-1 pb-[calc(env(safe-area-inset-bottom)+18px)] text-center">
        <p className="font-body text-[11px] tracking-[0.14em] uppercase text-white/40">
          Then continue your own Taste Test
        </p>
      </footer>
    </div>
  );
}
